import wordCloud from './WordCloud/wordCloud.js'
import barchart from './barchart.js'
import parallel from './ParallelCoord/parallel.js'
import pie from './pie.js'
import data from './data.js'

function makePorts(app) {
  app.ports.myExamplePortSendData.subscribe(function(str){
    app.ports.myExamplePortRecieveData.send(str);
  })

  app.ports.getFakeNews.subscribe(function () {
    data.fetchData(function(error, response){
      if (error) {
        console.error("No Data", error);
        return;
      }
      var keys = Object.keys(response).filter((key) => response[key].entities && response[key].sentiment)
      var data = keys.map(function(key, i){
        var toReturn = response[key];
        toReturn.key = key;
        toReturn.type_ = toReturn.type;
        if (toReturn.entities) {
          toReturn.entities.forEach((e) => {e.type_ = e.type});
        } else {
          toReturn.entities = [];
        }

        return toReturn;
      })
      app.ports.loadedFakeNews.send(data);
    })
  })

  app.ports.wordCloudCreate.subscribe(function(arg) {
    // Scott put d3 code in here. select #scott-svg;
    console.log("wc create", arg)
    var [dataset, numKeep, all] = arg;
    var entityData = wordCloud.getEntityDataForCloud(dataset, numKeep);
    wordCloud.drawWordCloud(entityData, app.ports.wordCloudTopicSelected.send);
    pie.makePie(all);
    var barData = barchart.getTypeCounts(all)
    barchart.makePie(barData);
  })

  app.ports.parallelCoordCreate.subscribe(function(dataset){
    console.log("pc create", dataset)
    var stripped_data = [];
    for (var i = 0; i < dataset.length; i++) {
      stripped_data.push({"entity" : dataset[i]["entity"], "negative" : dataset[i]["negative"], "neutral" : dataset[i]["neutral"], "positive" : dataset[i]["positive"]});
    }
    //parallel.makeParallel(stripped_data);

  })


  app.ports.isaiasPort.subscribe(function(dataset) {
    // Isaias put d3 code in here. select #isaias-svg;
    parallel.makeParallel(dataset);
  })
}

export default {
  makePorts: makePorts
}



// WEBPACK FOOTER //
// ./src/ports.js